export default __webpack_public_path__ + "static/navbar-209d18abbb51e5e0d9df1eec45c25c73.svg";